var _path;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInterests(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1359 3.48359C14.5216 2.82132 15.4784 2.82132 15.8641 3.48359L18.9809 8.83474C19.1222 9.07734 19.359 9.24937 19.6333 9.30879L25.6857 10.6194C26.4348 10.7816 26.7304 11.6915 26.2198 12.2631L22.0937 16.8809C21.9066 17.0902 21.8162 17.3686 21.8444 17.6479L22.4683 23.8091C22.5455 24.5716 21.7714 25.1339 21.0701 24.8249L15.4032 22.3277C15.1463 22.2145 14.8537 22.2145 14.5968 22.3277L8.9299 24.8249C8.22857 25.1339 7.45454 24.5716 7.53174 23.8091L8.15556 17.6479C8.18384 17.3686 8.0934 17.0902 7.90633 16.8809L3.78022 12.2631C3.26956 11.6915 3.56521 10.7816 4.31427 10.6194L10.3667 9.30879C10.641 9.24937 10.8778 9.07734 11.0191 8.83474L14.1359 3.48359Z",
    fill: "#4269EF"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInterests);
export default __webpack_public_path__ + "static/media/interests.07713211b4140b4cf70fa0ef02220627.svg";
export { ForwardRef as ReactComponent };